// Życzonka v2: wybór bombki w hero, kolory i koszyk (Shopify Ajax Cart API).
(() => {
  const NAMES = { cebulka: 'Cebulka', dzwonek: 'Dzwonek', balwan: 'Bałwan', choinka: 'Choinka', kolekcja: 'Komplet' };
  const ALIAS = { burgund: 'czerwony', 'ivory white': 'ivory', granatowy: 'granat', 'różowe złoto': 'rozowezloto', 'rozowe zloto': 'rozowezloto', 'rose gold': 'rozowezloto' };
  const money = (cents, cur = 'PLN') => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: cur, maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
  const root = () => window.Shopify?.routes?.root || '/';

  function init(el) {
    if (el.dataset.ready) return; el.dataset.ready = '1';
    let data = {}; try { data = JSON.parse(el.querySelector('.v2-data').textContent); } catch {}
    Object.values(data).forEach(p => p.variants?.forEach(v => { v.color = ALIAS[v.color] || v.color; }));

    // hero: wybór bombki; po kliknięciu pod spodem kolor + do koszyka, kolor modelu 3D = data-color przycisku
    const rack = el.querySelector('.rack'), cta = el.querySelector('[data-hero-cta]'), pick = el.querySelector('.hero-pick'); let selected = null;
    el.querySelectorAll('[data-select]').forEach(b => { b.dataset.color ||= 'czerwony'; });
    function showPick() {
      if (!pick) return;
      pick.setAttribute('aria-hidden', !selected); el.querySelector('.hero-swap')?.classList.toggle('picking', !!selected);
      pick.querySelectorAll('button').forEach(b => { b.tabIndex = selected ? 0 : -1; });
      if (!selected) return;
      const b = el.querySelector(`[data-select="${selected}"]`), color = b.dataset.color;
      pick.querySelector('[data-pick-name]').textContent = NAMES[selected];
      pick.querySelectorAll('.v2-swatch').forEach(s => s.setAttribute('aria-pressed', s.dataset.color === color));
      pick.querySelector('[data-color-name]').textContent = pick.querySelector('.v2-swatch[aria-pressed=true]')?.getAttribute('aria-label') || '';
      const v = variantFor(selected, color), add = pick.querySelector('[data-pick-add]');
      pick.querySelector('[data-pick-price]').textContent = v ? money(v.price) : el.querySelector(`.v2-card[data-product="${selected}"] [data-price]`)?.textContent || '';
      add.textContent = v && !v.available ? 'Chwilowo niedostępne' : 'Do koszyka'; add.disabled = !!v && !v.available;
      pick.querySelector('.v2-status').textContent = '';
      // panel pod wybraną bombką (na wąskim ekranie przyklejony do brzegu)
      const r = rack.getBoundingClientRect(), br = b.getBoundingClientRect(), half = pick.offsetWidth / 2;
      const x = Math.max(half - r.width / 2, Math.min(r.width / 2 - half, br.left + br.width / 2 - r.left - r.width / 2));
      pick.style.setProperty('--x', x + 'px');
    }
    rack?.addEventListener('click', e => {
      const b = e.target.closest('[data-select]'); if (!b) return;
      selected = selected === b.dataset.select ? null : b.dataset.select;
      rack.classList.toggle('has-selection', !!selected);
      el.querySelectorAll('[data-select]').forEach(x => { x.classList.toggle('selected', x.dataset.select === selected); x.setAttribute('aria-pressed', x.dataset.select === selected); });
      if (cta) cta.innerHTML = selected ? `Wybierz: ${NAMES[selected]} <span>↗</span>` : 'Odkryj kolekcję <span>↗</span>';
      showPick();
      if (selected) revealPick();
    });
    // panel wyboru bywa pod krawędzią ekranu; przewijamy tylko o tyle, ile trzeba
    function revealPick() {
      if (!pick) return;
      setTimeout(() => {
        if (!selected) return;
        const below = pick.getBoundingClientRect().bottom + 44 - innerHeight; // 44: zapas na wjazd panelu
        if (below > 0) scrollBy({ top: below, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, 60);
    }
    pick?.addEventListener('click', e => {
      if (!selected) return;
      const sw = e.target.closest('.v2-swatch');
      if (sw) { el.querySelector(`[data-select="${selected}"]`).dataset.color = sw.dataset.color; showPick(); return; }
      if (e.target.closest('[data-pick-add]')) addToCart(selected, el.querySelector(`[data-select="${selected}"]`).dataset.color, pick.querySelector('.v2-status'));
    });
    addEventListener('resize', () => selected && showPick());
    cta?.addEventListener('click', e => {
      if (!selected) return; e.preventDefault();
      const card = el.querySelector(`.v2-card[data-product="${selected}"]`); card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      card.classList.add('v2-flash'); setTimeout(() => card.classList.remove('v2-flash'), 1600);
    });
    el.querySelector('.pause')?.addEventListener('click', e => { const p = el.classList.toggle('paused'); e.currentTarget.setAttribute('aria-pressed', p); e.currentTarget.textContent = p ? '▷ Wznów ruch' : 'Ⅱ Zatrzymaj ruch'; });

    // karty: kolor, zdjęcie i cena wariantu, dodanie do koszyka
    const variantFor = (key, color) => { const v = data[key]?.variants || []; return v.find(x => x.color === color) || (v.length === 1 ? v[0] : null); };
    function sync(card) {
      const key = card.dataset.product, color = card.querySelector('.v2-swatch[aria-pressed=true]')?.dataset.color, v = variantFor(key, color);
      const name = card.querySelector('.v2-swatch[aria-pressed=true]')?.getAttribute('aria-label'); const label = card.querySelector('[data-color-name]'); if (label) label.textContent = name;
      if (v) card.querySelector('[data-price]').textContent = money(v.price);
      const photo = card.querySelector('.v2-photo img, .v2-bundle-photos img');
      if (photo && v?.image) { photo.src = v.image; photo.alt = `${data[key].title}, kolor ${name}`; }
      if (v) card.querySelectorAll('[data-pd-link]').forEach(a => { a.href = `${a.pathname}?variant=${v.id}`; });
      const add = card.querySelector('[data-add]'); add.textContent = v && !v.available ? 'Chwilowo niedostępne' : 'Do koszyka'; add.disabled = !!v && !v.available;
    }
    async function addToCart(key, color, status) {
      const v = variantFor(key, color);
      if (!v || !window.Shopify) { status.textContent = 'Ten wariant jest chwilowo niedostępny.'; return; }
      status.textContent = 'Dodajemy…';
      try {
        const r = await fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) });
        if (!r.ok) throw Error(); status.textContent = 'Dodano do koszyka.'; await window.zyCart.refresh(); window.zyCart.open();
      } catch { status.textContent = 'Nie udało się dodać. Spróbuj ponownie.'; }
    }
    el.querySelectorAll('[data-product]').forEach(card => {
      card.addEventListener('click', e => {
        const sw = e.target.closest('.v2-swatch');
        if (sw) { card.querySelectorAll('.v2-swatch').forEach(s => s.setAttribute('aria-pressed', s === sw)); sync(card); return; }
        if (!e.target.closest('[data-add]')) return;
        addToCart(card.dataset.product, card.querySelector('.v2-swatch[aria-pressed=true]')?.dataset.color, card.querySelector('.v2-status'));
      });
      sync(card);
    });

  }
  document.querySelectorAll('.zy-v2[data-zy-store]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.zy-v2[data-zy-store]').forEach(init));
})();
